<template>
  <exception-page type="500" />
</template>

<script>
export default {
  components: {},
};
</script>
